import React from 'react';
import { Column, ColumnContent, IColumnProps } from './Column';
import { withTranslate } from '../../../../../shared/i18n/translate';
import { ScheduledTime } from '../../../../shared/time/ui';
import { ColumnHeader } from '../../../../overview/ui/list/item/Column';

interface ITimeColumnProps extends IColumnProps {
	arrival: boolean;
	isDelayed: boolean;
	scheduledTimestamp: number;
	bestKnownTimestamp: number;
}

export const TimeColumn = withTranslate<ITimeColumnProps>(
	({
		t,
		arrival,
		isDelayed,
		scheduledTimestamp,
		bestKnownTimestamp,
		columns,
	}) => {
		const headerTranslationKey = arrival
			? 'flight_details_arrival_time'
			: 'flight_details_departure_time';

		return (
			<Column columns={columns}>
				<ColumnHeader>{t(headerTranslationKey)}</ColumnHeader>
				<ColumnContent>
					<ScheduledTime
						arrival={arrival}
						isDelayed={isDelayed}
						scheduledTimestamp={scheduledTimestamp}
						bestKnownTimestamp={bestKnownTimestamp}
					/>
				</ColumnContent>
			</Column>
		);
	},
);
